
import { DateTime } from "luxon";
import { luxonParseDate } from "./transformDate";

export const inAllowedTimeframe = (pastMonths = 3, futureMonths = 12, ...dates) => {

    const currentDate = DateTime.now();
    const pastThresholdDate = currentDate.minus({ months: pastMonths });
    const futureThresholdDate = currentDate.plus({ months: futureMonths });


    for (const date of dates) {
        if (date) {
            const d = DateTime.fromFormat(date, 'yyyy-MM-dd');
            let dIso = d.toISODate();
            if (d.ts < pastThresholdDate.ts) {
                return confirm(`Der ${dIso} liegt mehr als ${pastMonths} Monate in der Vergangenheit. Wollen Sie wirklich fortfahren?`);
            }
            if (d.ts > futureThresholdDate.ts) {
                return confirm(`Der ${dIso} liegt mehr als ${futureMonths} Monate in der Zukunft. Wollen Sie wirklich fortfahren?`);
            }
        }
    }
    return true;
};

export const spansOverYearChange = (startDate, endDate) => {
    const d_start = luxonParseDate(startDate);
    const d_end = luxonParseDate(endDate);
   
    if (d_start.year != d_end.year) {
        alert(`Das Ende ${d_end.toISODate()} liegt in einem anderen Jahr als der Start ${d_start.toISODate()}, dass ist nicht erlaubt. Bitte für jedes Jahr separat erfassen.`);
        return true;
    }
    return false;
    };


export default {inAllowedTimeframe, spansOverYearChange};